module.exports = __webpack_public_path__ + "static/media/7 up & down virtual.74592356.jpg";